var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25488",
    "data-name": "Grupo 25488",
    transform: "translate(-1157.149 -303)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2215",
    "data-name": "Elipse 2215",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1157.149 303)",
    fill: "#e5f4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69317",
    "data-name": "Trazado 69317",
    d: "M220.962,188.356h-8.223a2.94,2.94,0,0,0-2.937,2.937v7.048a2.94,2.94,0,0,0,2.937,2.937h8.223a2.94,2.94,0,0,0,2.937-2.937v-7.048A2.94,2.94,0,0,0,220.962,188.356Zm-8.223,1.175h8.223a1.762,1.762,0,0,1,1.633,1.108l-4.5,4.5a1.766,1.766,0,0,1-2.493,0l-4.5-4.5A1.762,1.762,0,0,1,212.739,189.531Zm8.223,10.573h-8.223a1.762,1.762,0,0,1-1.762-1.762v-6.167l3.8,3.794a2.941,2.941,0,0,0,4.154,0l3.8-3.794v6.167A1.762,1.762,0,0,1,220.962,200.1Z",
    transform: "translate(955.298 123.184)",
    fill: "#0099b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCorreo);
export default __webpack_public_path__ + "static/media/Icono-Correo.291515548c027b68b7920bf61faad56d.svg";
export { ForwardRef as ReactComponent };